import { Theme } from '../../domain';

export const THEMES: Theme[] = [
    new Theme(1, "Nutrition"),
    new Theme(2, "Positive Youth Development"),
    new Theme(3, "Sustainable Agriculture"),
    new Theme(4, "Water Conservation")
];
